import React from 'react';
import { useCart } from '../context/CartContext';
import RecentOrders from '../components/Home/RecentOrders';
import './OrdersPage.css';

const OrdersPage = () => {
    const { recentOrders } = useCart();

    return (
        <div className="orders-page">
            <div className="orders-header">
                <h1>Mis Pedidos</h1>
                <p>Historial de tus últimas disfrutadas</p>
            </div>

            <div className="orders-content">
                <RecentOrders
                    orders={recentOrders}
                    limit={10}
                    title="Historial de Pedidos (Últimos 10)"
                />
            </div>
        </div>
    );
};

export default OrdersPage;
